import { render, staticRenderFns } from "./SubjectsCreate.vue?vue&type=template&id=159367fa"
import script from "./SubjectsCreate.vue?vue&type=script&lang=js"
export * from "./SubjectsCreate.vue?vue&type=script&lang=js"
import style0 from "./SubjectsCreate.vue?vue&type=style&index=0&id=159367fa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports